module.exports = __webpack_public_path__ + "76b11c4367fcb177ba0f804f9228a9c5.pdf";